import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import { AiFillHome, AiOutlineInbox, AiOutlineUser, AiOutlineWallet } from "react-icons/ai";

class menu extends Component {
    state = {
        barcodeActive : "col-3 wp-item",
        transactionActive : "col-3 wp-item",
        settlementActive : "col-3 wp-item",
        profileActive : "col-3 wp-item"
    }
    componentDidMount(){
        // const pathname = window.location.pathname;
        // switch(pathname){
        //     case "/home":
        //         this.setState({barcodeActive: this.state.barcodeActive + " active"});
        //         break;
        //     case "/home/generate-barcode":
        //         this.setState({barcodeActive: this.state.barcodeActive + " active"});
        //         break;
        //     case "/home/transaction":
        //         this.setState({transactionActive: this.state.transactionActive + " active"});
        //         break;
        //     case "/home/complaints":
        //         this.setState({transactionActive: this.state.transactionActive + " active"});
        //         break;
        //     case "/home/settlement":
        //         this.setState({settlementActive: this.state.settlementActive + " active"});
        //         break;
        //     case "/profile":
        //         this.setState({profileActive: this.state.profileActive + " active"});
        //         break;
        //     default:
        //         this.setState({barcodeActive: this.state.barcodeActive + " active"});
        //         break;
        // }
    }
    render() { 
        return (  
            <nav className='bg-light wp-menu vh-100'>
                    <div className={this.state.barcodeActive}>
                    {/* {(window.location.pathname !== "/home/generate-barcode" && window.location.pathname !== "/home")?<React.Fragment><NavLink className='wp-link' to="/home/generate-barcode"><AiOutlineBarcode className='wp-link-icon' /><p>بارکدخوان</p></NavLink></React.Fragment>:<React.Fragment><AiOutlineBarcode className='wp-link-icon' /><p href="#" className='wp-link'>بارکدخوان</p></React.Fragment>} */}
                        <React.Fragment><NavLink className='wp-link' to="/home"><AiFillHome className='wp-link-icon' /><p>خدمات</p></NavLink></React.Fragment>
                    </div>
                    <div className={this.state.transactionActive}>
                    {/* {(window.location.pathname !== "/home/transaction")?<React.Fragment><NavLink className='wp-link' to="/home/transaction"><AiOutlineInbox className='wp-link-icon' /><p>تراکنش‌ها</p></NavLink></React.Fragment>:<React.Fragment><AiOutlineInbox className='wp-link-icon' /><p href="#" className='wp-link'>تراکنش‌ها</p></React.Fragment>} */}
                        <React.Fragment><NavLink className='wp-link' to="/complaints"><AiOutlineInbox className='wp-link-icon' /><p>نظام پیشنهادات</p></NavLink></React.Fragment>
                    </div>
                    <div className={this.state.settlementActive}>
                    {/* {(window.location.pathname !== "/home/settlement")?<React.Fragment><NavLink className='wp-link' to="/home/settlement"><AiOutlineWallet className='wp-link-icon' /><p>برداشت‌ها</p></NavLink></React.Fragment>:<React.Fragment><AiOutlineWallet className='wp-link-icon' /><p className='wp-link'>برداشت‌‌ها</p></React.Fragment>} */}
                        <React.Fragment><NavLink className='wp-link' to="/chat"><AiOutlineWallet className='wp-link-icon' /><p>تالار گفتگو</p></NavLink><span className="badge unseen bg-danger">{this.props.unSeen}</span></React.Fragment>
                    </div>
                    <div className={this.state.profileActive}>
                    {/* {(window.location.pathname !== "/profile")?<React.Fragment><NavLink className='wp-link' to="/profile"><AiOutlineUser className='wp-link-icon' /><p>پروفایل</p></NavLink></React.Fragment>:<React.Fragment><AiOutlineUser className='wp-link-icon' /><p className='wp-link'>پروفایل</p></React.Fragment>} */}
                        <React.Fragment><NavLink className='wp-link' to="/profile"><AiOutlineUser className='wp-link-icon' /><p>پروفایل</p></NavLink></React.Fragment>
                    </div>
            </nav>
        );
    }
}
 
export default menu;